import { AfterViewInit, Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { UserInfo } from './objects/user-info';
import { AppModule } from './app.module';
@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  
  constructor(
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
  }
  ngOnInit(): void {
  }

  ngAfterViewInit(){
  }

  setUserInfoByToken(){
    const activeAccount = this.msalService.instance.getActiveAccount();
    if (activeAccount) {
      let userInfoObj : UserInfo;
      let userInfo = sessionStorage.getItem("userInfo");
      if(userInfo){
        userInfoObj = JSON.parse(userInfo);
      }
      
      const claims = activeAccount.idTokenClaims;
      if (claims) {
        userInfoObj.email = (claims['preferred_username']) as string;
        userInfoObj.name = `${(claims['name'] || '') as string}`.trim();
        if (userInfoObj.jobTitle) {
          userInfoObj.jobTitle = userInfoObj.jobTitle.slice(0,19);
        }
      }
      
      sessionStorage.setItem("userInfo",JSON.stringify(userInfoObj));
    }
  }

}
